module.exports = __webpack_public_path__ + "img/ricerca_emt.228b73d5.png";